import MuiBackdrop, { BackdropProps as MuiBackdropProps } from '@mui/material/Backdrop';
import { PropsWithChildren } from 'react';

// Add custom props here:
export interface BackdropProps extends MuiBackdropProps {}

/**
 * In its simplest form, the Backdrop component is a dimmed layer over an area. It is useful for restricting interaction with UI elements while data is loading.
 */
export const Backdrop = ({ children, ...rest }: PropsWithChildren<BackdropProps>) => {
	return <MuiBackdrop {...rest}>{children}</MuiBackdrop>;
};
